export const BODY_LOCK_CLASS = "is-locked";

export const setAriaHidden = (element, isHidden) => {
  element?.setAttribute("aria-hidden", String(isHidden));
};

export const setBodyLocked = (documentReference, isLocked) => {
  documentReference?.body?.classList.toggle(BODY_LOCK_CLASS, isLocked);
};

export const focusModalPanel = (modal, selector) => {
  modal?.querySelector(selector)?.focus?.({ preventScroll: true });
};

export const storeModalTrigger = (modal, trigger, key = "__lastActiveTrigger") => {
  if (modal) {
    modal[key] = trigger ?? null;
  }
};

export const restoreModalTriggerFocus = (modal, key = "__lastActiveTrigger") => {
  modal?.[key]?.focus?.({ preventScroll: true });
  if (modal) {
    modal[key] = null;
  }
};

export const getOpenModal = (documentReference, selector, openClass) =>
  documentReference.querySelector(`${selector}.${openClass}`);
